import axios from "axios";
import { logDebug, logError } from "@/utils/logHelper";

// baseURL는 .env.*에 넣어두고 VITE_ 또는 VUE_APP_ 접두사 사용
/* ── 1) baseURL 우선순위 ──
 *    a. .env.{mode}            (Vue CLI  ‒ VUE_APP_BASE_FASTAPI_URL)
 *    b. .env.{mode}            (Vite     ‒ VITE_BASE_FASTAPI_URL)
 *    c. 하드코딩fallback       (개발 편의)
 */
const baseURL = process.env.VUE_APP_BASE_FASTAPI_URL; // VueCLI
// ?? import.meta.env.VITE_BASE_FASTAPI_URL    // Vite
//   ?? "http://localhost:8000";                 // Fallback (로컬)
// "http://210.180.0.245:8000";                 // Fallback (로컬)
//   "http://112.220.83.170:8000";                 // Fallback (로컬)
//"http://210.180.0.245:8000";
//
/** 프로젝트 전역 Axios인스턴스 */
const fastApiClient = axios.create({
  baseURL,
  timeout: 180_000, // 3분
  headers: { Accept: "application/json" },
});

/* ────────────────  인터셉터  ──────────────── */
fastApiClient.interceptors.request.use(
  (cfg) => {
    logDebug("[fastApiClient] ▶ Request", {
      url: cfg.url,
      method: cfg.method,
      params: cfg.params,
      isForm: cfg.data instanceof FormData,
      hasSignal: !!cfg.signal,
    });
    return cfg;
  },
  (err) => {
    logError("[fastApiClient] ❌ Request error", err);
    return Promise.reject(err);
  },
);

fastApiClient.interceptors.response.use(
  (res) => {
    const { data } = res; // { success, message, data, ... }
    logDebug("[fastApiClient] ◀ Response", data);

    // success 플래그는 FastAPI 공통 envelope 규약
    if (data?.success) return data;
    return Promise.reject({ ...data, isApiError: true });
  },
  (err) => {
    logError("[fastApiClient] ❌ Network/API error", err);
    return Promise.reject(err);
  },
);

export default fastApiClient;
